import * as React from "react";

import "./item-grid-1.scss";

import {cs}       from "@Common/react/chain-services";
import {keyed}    from "@Common/react/keyed";
import {ItemGrid} from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/select-type/item-grid";

export const ItemGrid1 = ({items, height, placeholder=null}) => cs(
    ["grid", ({}, next) => ItemGrid({
        minWidth: 250,
        maxWidth: 450,
        minGap: 20,
        maxGap: 100,
        count: (items?.length ?? 0) + 1,
        stretch: false,
        next,
    })],

    ({grid}) => {
        const marginRight = (index) => (index % grid.colCount === grid.colCount - 1) || index === (items?.length??0) ? undefined : grid.gapSize;
        return (
            <div className="item-grid-1-4dj" ref={grid.containerRef}>

                {placeholder && <div
                    className="placeholder-card"
                    style={{
                        width: grid.cellWidth,
                        height,
                        marginRight: marginRight(0),
                    }}
                >
                    <div className="middle">
                        <div className="message" xd-qa-type="label" xd-qa-name={placeholder.message}>
                            {placeholder.message}
                        </div>
                        <div className="actions">
                            <button
                                onClick={placeholder.action.onClick}
                                xd-qa-type="button"
                                xd-qa-name={placeholder.action.label}
                            >{placeholder.action.label}</button>
                        </div>
                    </div>
                </div>}

                {items?.map((item, i) => cs(
                    keyed(item.key),

                    ({}) => (
                        <div
                            className="card"
                            style={{
                                width: grid.cellWidth,
                                height,
                                marginRight: marginRight(i+1),
                            }}
                        >
                            {item.render()}
                        </div>
                    ),
                ))}
            </div>
        );
    },
);
